module.exports = "/_next/static/images/documents-logo-0b115e4148097baf5e88fd01c247dfc8.png";